import {clearOutput} from './../../utils/general'
import axios from 'axios'

export const preregistro = {
  async numeroIdentificacion ({output}) {
    let ct = output.contexto.contents
    output.outputWatson.json_response.push(ct.numeroIdentificacion)
    output.contexto.actions.before = ['preregistro.verificarIdentificacion']
    return output
  },
  async verificarIdentificacion ({output}) {
    output.contexto.contents.vars = {identificacion: output.input}
    let ct = output.contexto.contents
    output.outputWatson.json_response.push(ct.verificarIdentificacion)
    output.outputWatson.buttons = ['Continuar', 'Verificar']
    output.outputWatson.disableInput = true
    output.contexto.actions.before = ['preregistro.ingresaNombre']
    return output
  },
  async ingresaNombre ({output}) {
    if (output.input === 'Continuar') {
      let ct = output.contexto.contents
      output.outputWatson.json_response.push(ct.ingresaNombre)
      output.outputWatson.cancelAccept = true
      output.outputWatson.disableInput = true
      output.contexto.actions.before = ['preregistro.nombre']
      return output
    } else {
      return preregistro.numeroIdentificacion({output})
    }
  },
  async nombre ({output}) {
    if (output.input === 'true') {
      let ct = output.contexto.contents
      output.outputWatson.json_response.push(ct.nombre)
      output.contexto.actions.before = ['preregistro.email']
      return output
    } else {
      output.input = null
      return preregistro.email({output})
    }
  },
  async email ({output}) {
    let ct = output.contexto.contents
    if (ct.vars.name_ready == null && !ct.vars.name_ready) {
      output.contexto.contents.vars.nombre = output.input
    }
    output.outputWatson.json_response.push(ct.email)
    output.contexto.actions.before = ['preregistro.verificarEmail']
    return output
  },
  async verificarEmail ({output}) {
    output.contexto.contents.vars.email = output.input
    let ct = output.contexto.contents
    output.outputWatson.json_response.push(ct.verificarEmail)
    output.outputWatson.buttons = ['Continuar', 'Verificar']
    output.outputWatson.disableInput = true
    output.contexto.actions.before = ['preregistro.politicaDatos']
    return output
  },
  async politicaDatos ({output}) {
    if (output.input === 'Continuar') {
      let ct = output.contexto.contents
      output.outputWatson.json_response.push(ct.politicaDatos)
      output.outputWatson.cancelAccept = true
      output.outputWatson.disableInput = true
      output.contexto.actions.before = ['preregistro.final']
    } else {
      output.contexto.contents.vars.name_ready = true
      output = preregistro.email({output})
    }
    return output
  },
  async final ({output}) {
    let ct = output.contexto.contents
    if (output.input === 'true') {
      delete output.contexto.contents.vars.name_ready
      try {
        await axios.post(
          window.civiiConf.baseURL + '/civii/Chatbot/preregistro_impuestos',
          output.contexto.contents.vars
        )
        output.outputWatson.json_response.push(ct.final.mensaje)
        output.outputWatson.buttons = ct.final.botones
      } catch (err) {
        output.outputWatson.json_response.push(ct.error)
      }
    } else {
      output.outputWatson.json_response.push(ct.rechazaPoliticaDatos)
    }
    return clearOutput(output, 'contents')
  }
}



// WEBPACK FOOTER //
// ./src/impuestos/siteActions/preregistro.js